function subscribeMatchMedia(media, listener) {
    if (typeof media.addEventListener === "function") {
        media.addEventListener("change", listener);
        return () => media.removeEventListener("change", listener);
    }
    media.addListener(listener);
    return () => media.removeListener(listener);
}
/** Matches app mobile breakpoint (`$mobileBreakpoint` / Bootstrap lg). */
function isMobileViewport() {
    if (typeof window === "undefined") {
        return false;
    }
    return window.matchMedia("(max-width: 991px)").matches;
}
/** iPhone, iPod, iPad (incl. iPadOS desktop UA). */
function isIOSWebKit() {
    if (typeof navigator === "undefined") {
        return false;
    }
    return (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));
}
/** Prefer full navigation on iOS Safari — client-side transitions cancel in-flight fetches. */
function shouldUseFullPageNavigation() {
    return isIOSWebKit();
}
function replaceLocation(url) {
    window.location.replace(url);
}

export { isIOSWebKit, isMobileViewport, replaceLocation, shouldUseFullPageNavigation, subscribeMatchMedia };
//# sourceMappingURL=browser.js.map
